<template>
  <div>
    <DeleteModal
      @close-delete-modal="showDeleteModal = !showDeleteModal"
      @deleteItem="deleteEvangelio"
      @cancelDeleteProcess="cancelDeleteProcess"
      v-if="showDeleteModal"
      itemType="Evangelio"
      />
    <EvangelioModal
      @close-modal="showModal = !showModal"
      @save="save"
      @hideModal="showModal = !showModal"
      v-if="showModal"
      :evangelioObject="evangelioObject"
    />
    <div class="flex justify-between items-center py-4">
      <h2
        class="text-blueGray-700 text-lg font-semibold">
        Evangelio list
      </h2>
      <button
        @click="openModal"
        class="bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded">Add Evangelio</button>
    </div>
    <div class="app-block mb-22 shadow-lg">
      <div class="">
          <ul>
            <li 
              v-for="(evangelio, idx) in evangelioList"
              :key="idx"
              class="flex justify-between pt-4 pb-4">
              <div class="">
                <h2
                  v-html="evangelio.title"
                  class="text-lg font-semibold">
                </h2>
                <p
                  v-if="evangelio.categoryId"
                  class="font-semibold text-xs">Category:
                  <span class="text-xs font-normal">
                    {{ categoryName(evangelio.categoryId) }}
                  </span>
                </p>
              </div>
              <div class="flex justify-between">
                <span>
                  <i
                    @click="edit(evangelio._id)"
                    class="fas fa-pencil-alt cursor-pointer"></i>
                </span>
                <span>
                  <i
                    @click="showDeleteEvangelioModal(evangelio._id)"
                    class="fas fa-trash-alt ml-4 cursor-pointer"></i>
                </span>
              </div>
            </li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
import EvangelioModal from '@/components/modals/EvangelioModal';
import DeleteModal from '@/components/modals/DeleteModal';
import { ToastSuccess, ToastError } from '../utils/Swal'
import FirebaseStorage from '../utils/fileUpload'
import { mapStores } from 'pinia'
import { useGeneralStore } from '@/stores/index.js'
import axios from 'axios'

export default {
  components: {
    EvangelioModal,
    DeleteModal
  },

  data() {
    return {
      evangelioObject: {},
      evangelioList: [],
      showModal: false,
      showDeleteModal: false,
      idOfItemToDelete: null,
      generalStore: useGeneralStore(),
      evangelioObjectToSave: {},
      firebaseStorage: new FirebaseStorage()
    }
  },

  computed: {
    ...mapStores(useGeneralStore)
  },

  methods: {

    openModal() {
      this.evangelioObject = {}
      this.showModal = !this.showModal
    },

    categoryName(id) {
      const category = this.generalStore.getCategories.find(category => category._id === id)
      if (category) {
        return category.name
      } else {
        return ''
      }
    },

    async save(object) {
      this.evangelioObjectToSave = object

      if (object.file !== null) {
        if (this.evangelioObjectToSave.queryMode === 'new') {
          await this.saveFileInStorage()
        } else if (this.evangelioObjectToSave.queryMode === 'edit') {
          await this.editFileInStorage() 
        }
        this.databaseHandler()
      } else {
        this.databaseHandler()
      }
    },

    async databaseHandler() {
      try {
        const { data: response } = await axios.post(`${process.env.VUE_APP_DOMAIN_NAME}/api/admin/${this.evangelioObjectToSave.queryMode}-evangelio`, 
          this.evangelioObjectToSave.form,
          { withCredentials: true })
      
        if (response.saved) {
          ToastSuccess.fire({
            title: `<p style="color: #fff";>${response.message}</p>`
          })

          if (this.evangelioObjectToSave.queryMode === 'new') {
            this.generalStore.setNewEvangelio(response.doc)
          } else if (this.evangelioObjectToSave.queryMode === 'edit') {
            this.generalStore.editEvangelio(response.doc)
            this.refreshList()
          }
        }
      } catch (error) {
        if (error.response) {
          ToastError.fire({
            title: `<p style="color: #fff";>${error.response.data.message}</p>`
          })
        } else {
          console.log(error);
        }
      }
    },

    async saveFileInStorage() {
      let uniqueId = Date.now().toString(36) + Math.random().toString(36).substring(2);
      this.evangelioObjectToSave.form.filePath = `${this.evangelioObjectToSave.path}/${uniqueId}/`

      const payload = await this.firebaseStorage.save({
        file: this.evangelioObjectToSave.file,
        path: this.evangelioObjectToSave.form.filePath
      })

      this.evangelioObjectToSave.form.filename = payload.file.name
      this.evangelioObjectToSave.form.downloadURL = payload.file.downloadURL
    },

    async editFileInStorage() {
      const payload = await this.firebaseStorage.edit({
        file: this.evangelioObjectToSave.file,
        previousFilename: this.evangelioObjectToSave.form.filename,
        path: this.evangelioObjectToSave.form.filePath
      })
          
      this.evangelioObjectToSave.form.filename = payload.file.name
      this.evangelioObjectToSave.form.downloadURL = payload.file.downloadURL
    },
    
    edit(id) {
      this.evangelioObject = this.evangelioList.find(evangelio => evangelio._id === id)
      this.showModal = !this.showModal
    },

    cancelDeleteProcess() {
      this.idOfItemToDelete = null
      this.showDeleteModal = false
    },

    async deleteEvangelio() {
      try {
        const { data: response } = await axios.post(`${process.env.VUE_APP_DOMAIN_NAME}/api/admin/delete-evangelio`,
        { id: this.idOfItemToDelete },
        { withCredentials: true })

        if (response.deleted) {
          this.firebaseStorage.delete({
            path: response.doc.filePath,
            previousFilename: response.doc.filename
          })

          this.generalStore.deleteEvangelio(this.idOfItemToDelete)
          this.idOfItemToDelete = null
          this.refreshList()
          this.showDeleteModal = false
        }
      } catch (error) {
        if (error.response) {
          ToastError.fire({
            title: `<p style="color: #fff";>${error.response.data.message}</p>`
          })
        } else {
          console.log(error);
        }
      }
    },

    showDeleteEvangelioModal(id) {
      this.idOfItemToDelete = id
      this.showDeleteModal = true
    },
    
    refreshList() {
      this.evangelioList = this.$store.state.evangelio
    }
  },

  async mounted() {
    try {
      const { data: response } = await axios.post(`${process.env.VUE_APP_DOMAIN_NAME}/api/admin/get-evangelio`, {},
      { withCredentials: true })
      if (response.doc) {
        this.generalStore.loadEvangelio(response.doc)
        this.evangelioList = this.generalStore.getEvangelio
      }
    } catch (error) {
      if (error.response) {
        ToastError.fire({
          title: `<p style="color: #fff";>${error.response.data.message}</p>`
        })
      } else {
        console.log(error);
      }
    }
  }
}
</script>

<style scoped>

  ul li {
    border-top: 1px solid grey;
  }

  ul li:first-child {
    border-top: 0px solid grey;
  }
</style>